import { observer } from 'mobx-react';
import { StateLicenseTaskForm } from 'libs/feature-loan-details/src/loanDetails/components/stateLicenseTaskForm';
import { TodoItem } from 'libs/feature-loan-details/src/loanDetails/utils/loanDetailsTypes';
import { Document } from '@roc/feature-types';
import { CustomTaskDialog, useGeneralTasksStore } from '@roc/feature-general-tasks';
import { CircularProgress, Box } from '@material-ui/core';

interface Props {
  open: boolean;
  onClose: () => void;
  document: Document;
  onSubmitted?: () => void;
}

const StateLicenseContent = observer(({ document, onSubmitted }: { document: Document; onSubmitted?: () => void }) => {
  const { generalTasksStore } = useGeneralTasksStore();
  const { attachmentStore, taskV2 } = generalTasksStore.editTaskStore;

  if (!taskV2?.taskId) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight={100}>
        <CircularProgress size={32} />
      </Box>
    );
  }

  const taskDocuments = taskV2?.taskDocuments ?? [];
  const todo: TodoItem = { document } as TodoItem;
  const firstDoc = taskDocuments[0];

  const handleDownload = firstDoc
    ? () => attachmentStore.downloadDocument({
        taskAttachmentId: firstDoc.taskDocumentId,
        taskId: firstDoc.taskId,
        documentId: firstDoc.taskDocumentId,
        attachmentName: firstDoc.originalFileName,
      })
    : undefined;

  return (
    <StateLicenseTaskForm
      todo={todo}
      onSubmitted={onSubmitted}
      existingFileName={firstDoc?.originalFileName}
      onDownloadExisting={handleDownload}
    />
  );
});

export const StateLicenseTaskDialog = observer(({ open, onClose, document, onSubmitted }: Props) => {
  if (!document) return null;

  return (
    <CustomTaskDialog
      open={open}
      title={document.taskName}
      handleClose={onClose}
      dialogContent={<StateLicenseContent document={document} onSubmitted={onSubmitted} />}
      taskId={document?.taskId}
    />
  );
});
